/* eslint-disable no-unused-vars */
import { ResursTreeApi } from '../../../services/modules/tree'
import { TResursTreeNode } from '../treeTypes'

export const handleAddDevice = async (
	treeName: ResursTreeApi.treeName,
	node: TResursTreeNode,
	setShowCreateModal: (arg: boolean) => void,
	setTreeObjectListAvailableToAdd: (arg: any) => void
) => {
	/**
	 * Нужны доп проверки на то кто это вообще
	 */
	let parentId

	if (!node) {
		parentId = ['0']
	} else {
		parentId = [node.id]
	}

	const response = await ResursTreeApi.getTreeObjectListAvailableToAdd({
		tree: treeName,
		parentId: parentId,
		nodeClass: node ? node.className : 'root',
	})

	if (response && response.list.length > 0) {
		setTreeObjectListAvailableToAdd(response)
		setShowCreateModal(true)
	}
}
